import React, { createContext, useContext, useEffect, useState } from "react";
import apiCDS from "../services/apiCDS";
import apiCMS from "../services/apiCMS";
import { useAuthContext } from "./AuthContext";
import { requests } from "../services/requests";
import { verifyPromoLastHours, verifyPromoDates } from "../util/util";

const GeneralContext = createContext();

const GeneralContextProvider = ({ children }) => {
  const [generalContextLoading, setGeneralContextLoading] = useState(true);
  const [user, setUser] = useState({});
  const [categories, setCategories] = useState([]);
  const [promotionalBanner, setPromotionalBanner] = useState({});

  const { isLoggedIn } = useAuthContext();

  useEffect(() => {
    const getData = async () => {
      const { data: categoryCourses } = await apiCDS.get(`/categories/courses`);
      const { data: promotionalBanner } = await apiCMS.get(
        `/banner?populate=*`
      );

      const filteredCategories = categoryCourses.filter(
        (course) => course.slug !== "sem-categoria"
      );

      setCategories(filteredCategories);
      setPromotionalBanner(promotionalBanner.data);
      setGeneralContextLoading(false);
    };

    getData();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      requests
        .getUser()
        .then(({ data }) => {
          setUser(data.userData);
        })
        .catch((error) => console.error(error));
    } else {
      setUser({});
    }
  }, [isLoggedIn]);

  return (
    <GeneralContext.Provider
      value={{
        categories,
        promotionalBanner,
        generalContextLoading,
        user,
      }}
    >
      {children}
    </GeneralContext.Provider>
  );
};

const useGeneralContext = () => {
  const { categories, promotionalBanner, generalContextLoading, user } =
    useContext(GeneralContext);

  const { startDate, endDate } = promotionalBanner;
  const promoStart = startDate && `${startDate}T00:00:00-03:00`;
  const promoEnd = endDate && `${endDate}T23:59:59-03:00`;

  const isPromoPeriod = verifyPromoDates(promoStart, promoEnd);
  const showCountdown = isPromoPeriod && verifyPromoLastHours(promoEnd);
  const hasPromotionalBannerImages =
    !!promotionalBanner.largeBanner && !!promotionalBanner.largeBanner;

  const allCourses = categories.map((category) => category.courses).flat();

  return {
    categories,
    isPromoPeriod,
    showCountdown,
    promoEnd,
    hasPromotionalBannerImages,
    promotionalBanner,
    allCourses,
    generalContextLoading,
    user,
  };
};

export { GeneralContext, GeneralContextProvider, useGeneralContext };
